// ServiceOverview/CmdEnvsFetcher.js
// Singleton — raw I/O via CmdEnvsService.
import cmdEnvsService from '../../../services/CmdEnvsService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'CmdEnvsFetcher';

class CmdEnvsFetcher extends CoreBase {
    _name = _name;

    /**
     * @returns {Promise<object[]|null>} cmd envs per vendor instance, null when the request failed
     */
    fetch = async () => {
        try {
            const response = await cmdEnvsService.getCmdEnvs();
            const items = response?.data?.items;
            if (this._isOk(response) && Array.isArray(items)) return items;

            this.logError('fetch', `no cmd envs — HTTP ${response?.status ?? 'none'}`);
            return null;
        } catch (error) {
            this.logError('fetch', error.message);
            return null;
        }
    };

    /**
     * Result arrives async via SignalR OnCmdEnvsUpdated.
     * @param {object[]} items - [{ app, machine, envs }], full set of envs per vendor instance
     * @returns {Promise<boolean>} request accepted
     */
    post = async (items) => {
        try {
            const response = await cmdEnvsService.postCmdEnvs(items);
            if (this._isOk(response)) return true;

            this.logError('post', `cmd envs not accepted — HTTP ${response?.status ?? 'none'}`);
            return false;
        } catch (error) {
            this.logError('post', error.message);
            return false;
        }
    };

    _isOk = (response) => response?.status >= 200 && response?.status < 300;
}

const cmdEnvsFetcher = new CmdEnvsFetcher();
export default cmdEnvsFetcher;
